// sessionStorage操作
export function setStore(name, content) {
  if (!name) {
    return;
  }
  window.sessionStorage.setItem(name, content);
}
export function getStore(name) {
  let rtn = '';

  if (name) {
    rtn = window.sessionStorage.getItem(name);
  }
  return rtn;
}
export function removeStore(name) {
  if (!name) {
    return;
  }
  window.sessionStorage.removeItem(name);
}

export function rem(wsize = 750) {
  var originalSize = parseInt((window.getComputedStyle(document.documentElement, null)).fontSize);
  var resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize';

  if (!document.addEventListener) return;
  reCalc();
  window.addEventListener(resizeEvt, reCalc, false);
  document.addEventListener('DOMContentLoaded', reCalc, false);

  function reCalc() {
      var win_w = parseInt(window.innerWidth);
      var win_h = parseInt(window.innerHeight);
      /* 对应页面最大设计尺寸大宽度设置size */
      // win_w = win_w > wsize ? wsize : win_w;

      var html = document.getElementsByTagName('html')[0];
      var zoom
      if(isMobile()) {
        zoom = (win_w / wsize) / (originalSize / 16) * 100;
      } else {
        zoom = (win_h / wsize) / (originalSize / 16) * 100;
      }
      html.style.fontSize = zoom + 'px';
  }
}

export function isWeiXin() {
  // window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
  var ua = window.navigator.userAgent.toLowerCase();
  // 通过正则表达式匹配ua中是否含有MicroMessenger字符串
  return /micromessenger/.test(ua);
}

export function isAndroid() {
  // window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
  var ua = window.navigator.userAgent.toLowerCase();
  return ua.indexOf('android') > -1 || ua.indexOf('adr') > -1;
}

export function isMobile() {
  // if (/Wechat/.test(navigator.userAgent)) {
  //     return false;
  // }
  if (
    /AppleWebKit.*Mobile/i.test(navigator.userAgent) ||
        /Android|iPhone|Windows Phone|webOS|iPod|BlackBerry/i.test(navigator.userAgent)
  ) {
    return true;
  }
  return false;
}

export function getParameterByName(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
  var results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

export function loadImage(src) {
  return new Promise((resolve,reject) => {
    let img = new Image()
    img.onload = () => { //加载时执行resolve
      resolve(img)
    }
    img.onerror = () => { //
      reject(src)
    }
    img.src = src
  })
}

export function getDeviceRatio() {
  var isIPhone = window.navigator.appVersion.match(/iphone/gi);
  var devicePixelRatio = window.devicePixelRatio;
  var dpr;
  if (isIPhone) {
    // iOS下，对于2和3的屏，用2倍的方案，其余的用1倍方案
    if (devicePixelRatio >= 3) {
      dpr = 3;
    } else if (devicePixelRatio >= 2) {
      dpr = 2;
    } else {
      dpr = 1;
    }
  } else {
    // 其他设备下，仍旧使用1倍的方案
    dpr = 1;
  }
  return dpr
}
